// @generated by protobuf-ts 2.11.1 with parameter generate_dependencies,long_type_number,ts_nocheck,optimize_code_size
// @generated from protobuf file "c1/api/policy/v1/policy_step_form.proto" (package "c1.api.policy.v1", syntax proto3)
// tslint:disable
// @ts-nocheck
import type { BinaryWriteOptions } from "@protobuf-ts/runtime";
import type { IBinaryWriter } from "@protobuf-ts/runtime";
import { WireType } from "@protobuf-ts/runtime";
import type { BinaryReadOptions } from "@protobuf-ts/runtime";
import type { IBinaryReader } from "@protobuf-ts/runtime";
import { UnknownFieldHandler } from "@protobuf-ts/runtime";
import type { PartialMessage } from "@protobuf-ts/runtime";
import { reflectionMergePartial } from "@protobuf-ts/runtime";
import { MessageType } from "@protobuf-ts/runtime";
import { Timestamp } from "../../../../google/protobuf/timestamp";
import { SkippedAction } from "./shared_policy_outcomes";
import { ReassignedAction } from "./shared_policy_outcomes";
import { RestartAction } from "./shared_policy_outcomes";
import { Struct } from "../../../../google/protobuf/struct";
import { Form as Form$ } from "../../form/v1/form";
/**
 * @generated from protobuf message c1.api.policy.v1.Form
 */
export interface Form {
    /**
     * @generated from protobuf field: c1.api.form.v1.Form form = 1
     */
    form?: Form$;
}
/**
 * @generated from protobuf message c1.api.policy.v1.FormInstance
 */
export interface FormInstance {
    /**
     * @generated from protobuf field: c1.api.form.v1.Form form = 1
     */
    form?: Form$;
    /**
     * @generated from protobuf field: google.protobuf.Struct data = 2
     */
    data?: Struct;
    /**
     * @generated from protobuf field: c1.api.policy.v1.FormInstanceState state = 3
     */
    state: FormInstanceState;
    /**
     * @generated from protobuf oneof: outcome
     */
    outcome: {
        oneofKind: "completed";
        /**
         * @generated from protobuf field: c1.api.policy.v1.FormCompletedAction completed = 100
         */
        completed: FormCompletedAction;
    } | {
        oneofKind: "restarted";
        /**
         * @generated from protobuf field: c1.api.policy.v1.RestartAction restarted = 101
         */
        restarted: RestartAction;
    } | {
        oneofKind: "reassigned";
        /**
         * @generated from protobuf field: c1.api.policy.v1.ReassignedAction reassigned = 102
         */
        reassigned: ReassignedAction;
    } | {
        oneofKind: "skipped";
        /**
         * @generated from protobuf field: c1.api.policy.v1.SkippedAction skipped = 103
         */
        skipped: SkippedAction;
    } | {
        oneofKind: undefined;
    };
}
/**
 * @generated from protobuf message c1.api.policy.v1.FormCompletedAction
 */
export interface FormCompletedAction {
    /**
     * @generated from protobuf field: string user_id = 1
     */
    userId: string;
    /**
     * @generated from protobuf field: google.protobuf.Timestamp completed_at = 2
     */
    completedAt?: Timestamp;
}
/**
 * @generated from protobuf enum c1.api.policy.v1.FormInstanceState
 */
export enum FormInstanceState {
    /**
     * @generated from protobuf enum value: FORM_INSTANCE_STATE_UNSPECIFIED = 0;
     */
    UNSPECIFIED = 0,
    /**
     * @generated from protobuf enum value: FORM_INSTANCE_STATE_WAITING = 1;
     */
    WAITING = 1,
    /**
     * @generated from protobuf enum value: FORM_INSTANCE_STATE_DONE = 2;
     */
    DONE = 2
}
// @generated message type with reflection information, may provide speed optimized methods
class Form$Type extends MessageType<Form> {
    constructor() {
        super("c1.api.policy.v1.Form", [
            { no: 1, name: "form", kind: "message", T: () => Form$ }
        ]);
    }
    create(value?: PartialMessage<Form>): Form {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<Form>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: Form): Form {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* c1.api.form.v1.Form form */ 1:
                    message.form = Form$.internalBinaryRead(reader, reader.uint32(), options, message.form);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: Form, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* c1.api.form.v1.Form form = 1; */
        if (message.form)
            Form$.internalBinaryWrite(message.form, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.policy.v1.Form
 */
export const Form = new Form$Type();
// @generated message type with reflection information, may provide speed optimized methods
class FormInstance$Type extends MessageType<FormInstance> {
    constructor() {
        super("c1.api.policy.v1.FormInstance", [
            { no: 1, name: "form", kind: "message", T: () => Form$ },
            { no: 2, name: "data", kind: "message", T: () => Struct },
            { no: 3, name: "state", kind: "enum", T: () => ["c1.api.policy.v1.FormInstanceState", FormInstanceState, "FORM_INSTANCE_STATE_"] },
            { no: 100, name: "completed", kind: "message", oneof: "outcome", T: () => FormCompletedAction },
            { no: 101, name: "restarted", kind: "message", oneof: "outcome", T: () => RestartAction },
            { no: 102, name: "reassigned", kind: "message", oneof: "outcome", T: () => ReassignedAction },
            { no: 103, name: "skipped", kind: "message", oneof: "outcome", T: () => SkippedAction }
        ]);
    }
    create(value?: PartialMessage<FormInstance>): FormInstance {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.state = 0;
        message.outcome = { oneofKind: undefined };
        if (value !== undefined)
            reflectionMergePartial<FormInstance>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: FormInstance): FormInstance {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* c1.api.form.v1.Form form */ 1:
                    message.form = Form$.internalBinaryRead(reader, reader.uint32(), options, message.form);
                    break;
                case /* google.protobuf.Struct data */ 2:
                    message.data = Struct.internalBinaryRead(reader, reader.uint32(), options, message.data);
                    break;
                case /* c1.api.policy.v1.FormInstanceState state */ 3:
                    message.state = reader.int32();
                    break;
                case /* c1.api.policy.v1.FormCompletedAction completed */ 100:
                    message.outcome = {
                        oneofKind: "completed",
                        completed: FormCompletedAction.internalBinaryRead(reader, reader.uint32(), options, (message.outcome as any).completed)
                    };
                    break;
                case /* c1.api.policy.v1.RestartAction restarted */ 101:
                    message.outcome = {
                        oneofKind: "restarted",
                        restarted: RestartAction.internalBinaryRead(reader, reader.uint32(), options, (message.outcome as any).restarted)
                    };
                    break;
                case /* c1.api.policy.v1.ReassignedAction reassigned */ 102:
                    message.outcome = {
                        oneofKind: "reassigned",
                        reassigned: ReassignedAction.internalBinaryRead(reader, reader.uint32(), options, (message.outcome as any).reassigned)
                    };
                    break;
                case /* c1.api.policy.v1.SkippedAction skipped */ 103:
                    message.outcome = {
                        oneofKind: "skipped",
                        skipped: SkippedAction.internalBinaryRead(reader, reader.uint32(), options, (message.outcome as any).skipped)
                    };
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: FormInstance, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* c1.api.form.v1.Form form = 1; */
        if (message.form)
            Form$.internalBinaryWrite(message.form, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* google.protobuf.Struct data = 2; */
        if (message.data)
            Struct.internalBinaryWrite(message.data, writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        /* c1.api.policy.v1.FormInstanceState state = 3; */
        if (message.state !== 0)
            writer.tag(3, WireType.Varint).int32(message.state);
        /* c1.api.policy.v1.FormCompletedAction completed = 100; */
        if (message.outcome.oneofKind === "completed")
            FormCompletedAction.internalBinaryWrite(message.outcome.completed, writer.tag(100, WireType.LengthDelimited).fork(), options).join();
        /* c1.api.policy.v1.RestartAction restarted = 101; */
        if (message.outcome.oneofKind === "restarted")
            RestartAction.internalBinaryWrite(message.outcome.restarted, writer.tag(101, WireType.LengthDelimited).fork(), options).join();
        /* c1.api.policy.v1.ReassignedAction reassigned = 102; */
        if (message.outcome.oneofKind === "reassigned")
            ReassignedAction.internalBinaryWrite(message.outcome.reassigned, writer.tag(102, WireType.LengthDelimited).fork(), options).join();
        /* c1.api.policy.v1.SkippedAction skipped = 103; */
        if (message.outcome.oneofKind === "skipped")
            SkippedAction.internalBinaryWrite(message.outcome.skipped, writer.tag(103, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.policy.v1.FormInstance
 */
export const FormInstance = new FormInstance$Type();
// @generated message type with reflection information, may provide speed optimized methods
class FormCompletedAction$Type extends MessageType<FormCompletedAction> {
    constructor() {
        super("c1.api.policy.v1.FormCompletedAction", [
            { no: 1, name: "user_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "completed_at", kind: "message", T: () => Timestamp }
        ]);
    }
    create(value?: PartialMessage<FormCompletedAction>): FormCompletedAction {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.userId = "";
        if (value !== undefined)
            reflectionMergePartial<FormCompletedAction>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: FormCompletedAction): FormCompletedAction {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string user_id */ 1:
                    message.userId = reader.string();
                    break;
                case /* google.protobuf.Timestamp completed_at */ 2:
                    message.completedAt = Timestamp.internalBinaryRead(reader, reader.uint32(), options, message.completedAt);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: FormCompletedAction, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string user_id = 1; */
        if (message.userId !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.userId);
        /* google.protobuf.Timestamp completed_at = 2; */
        if (message.completedAt)
            Timestamp.internalBinaryWrite(message.completedAt, writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.policy.v1.FormCompletedAction
 */
export const FormCompletedAction = new FormCompletedAction$Type();
